import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Spinner } from "@/components/rp";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import LeadForm from "@/pages/LeadForm";
import ClientDocumenti from "@/pages/client/ClientDocumenti";
import ClientMessaggi from "@/pages/client/ClientMessaggi";
import ClientDiario from "@/pages/client/ClientDiario";
import ClientProfilo from "@/pages/client/ClientProfilo";
import AdminCantiereDetail from "@/pages/admin/AdminCantiereDetail";
import AdminClienti from "@/pages/admin/AdminClienti";
import AdminClienteDetail from "@/pages/admin/AdminClienteDetail";
import AdminMessaggi from "@/pages/admin/AdminMessaggi";
import AdminChat from "@/pages/admin/AdminChat";
import AdminAgenda from "@/pages/admin/AdminAgenda";
import AdminPreventivi from "@/pages/admin/AdminPreventivi";
import AdminPreventivoDetail from "@/pages/admin/AdminPreventivoDetail";
import AdminCommesse from "@/pages/admin/AdminCommesse";
import AdminCommessaDetail from "@/pages/admin/AdminCommessaDetail";
import AdminSoddisfazione from "@/pages/admin/AdminSoddisfazione";
import AdminAmministrazione from "@/pages/admin/AdminAmministrazione";
import AdminAmministrazioneDetail from "@/pages/admin/AdminAmministrazioneDetail";
import AdminScadenzario from "@/pages/admin/AdminScadenzario";
import AdminSubappalti from "@/pages/admin/AdminSubappalti";
import AdminStatistiche from "@/pages/admin/AdminStatistiche";
import SetPassword from "@/pages/SetPassword";
import ImpresaPage from "@/pages/Impresa";
import PrimaDopoPage from "@/pages/PrimaDopo";
import PreventivoPubblico from "@/pages/PreventivoPubblico";
import AdminOggi from "@/pages/admin/AdminOggi";
import AdminSopralluoghi from "@/pages/admin/AdminSopralluoghi";
import AdminDiario from "@/pages/admin/AdminDiario";
import AdminAvvisi from "@/pages/admin/AdminAvvisi";
import ClientPreventivi from "@/pages/client/ClientPreventivi";
import ClientCommessa from "@/pages/client/ClientCommessa";

const home = (u) => (u?.role === "admin" ? "/admin/commesse" : "/commessa");

const RequireAuth = ({ role, children }) => {
  const { user } = useAuth();
  if (user === undefined) return <Spinner />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== role) return <Navigate to={home(user)} replace />;
  return children;
};

const Fallback = () => {
  const { user } = useAuth();
  if (user === undefined) return <Spinner />;
  return <Navigate to={user ? home(user) : "/login"} replace />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/imposta-password" element={<SetPassword />} />
          <Route path="/impresa/:token" element={<ImpresaPage />} />
          <Route path="/prima-dopo/:oid" element={<PrimaDopoPage />} />
          <Route path="/preventivo/:qid" element={<PreventivoPubblico />} />
          <Route path="/richiesta-preventivo" element={<LeadForm />} />
          <Route element={<RequireAuth role="client"><Layout /></RequireAuth>}>
            <Route path="/cantiere" element={<Navigate to="/commessa" replace />} />
            <Route path="/documenti" element={<ClientDocumenti />} />
            <Route path="/preventivi" element={<ClientPreventivi />} />
            <Route path="/commessa" element={<ClientCommessa />} />
            <Route path="/messaggi" element={<ClientMessaggi />} />
            <Route path="/diario" element={<ClientDiario />} />
            <Route path="/profilo" element={<ClientProfilo />} />
          </Route>
          <Route element={<RequireAuth role="admin"><Layout /></RequireAuth>}>
            <Route path="/admin" element={<Navigate to="/admin/commesse" replace />} />
            <Route path="/admin/cantieri/:id" element={<AdminCantiereDetail />} />
            <Route path="/admin/clienti" element={<AdminClienti />} />
            <Route path="/admin/clienti/:id" element={<AdminClienteDetail />} />
            <Route path="/admin/messaggi" element={<AdminMessaggi />} />
            <Route path="/admin/messaggi/:clientId" element={<AdminChat />} />
            <Route path="/admin/agenda" element={<AdminAgenda />} />
            <Route path="/admin/preventivi" element={<AdminPreventivi />} />
            <Route path="/admin/preventivi/:id" element={<AdminPreventivoDetail />} />
            <Route path="/admin/commesse" element={<AdminCommesse />} />
            <Route path="/admin/commesse/:id" element={<AdminCommessaDetail />} />
            <Route path="/admin/soddisfazione" element={<AdminSoddisfazione />} />
            <Route path="/admin/amministrazione" element={<AdminAmministrazione />} />
            <Route path="/admin/amministrazione/scadenzario" element={<AdminScadenzario />} />
            <Route path="/admin/subappalti" element={<AdminSubappalti />} />
            <Route path="/admin/statistiche" element={<AdminStatistiche />} />
            <Route path="/admin/diario" element={<AdminDiario />} />
            <Route path="/admin/avvisi" element={<AdminAvvisi />} />
            <Route path="/admin/oggi" element={<AdminOggi />} />
            <Route path="/admin/sopralluoghi" element={<AdminSopralluoghi />} />
            <Route path="/admin/amministrazione/:id" element={<AdminAmministrazioneDetail />} />
          </Route>
          <Route path="*" element={<Fallback />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </AuthProvider>
  );
}

export default App;
